export const SystemEmails = {
    customerService: 'Customer.Service@EnterpriseWireless.org',
} as const;
